var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-picker",style:({ backgroundColor: _vm.color ? _vm.color : '' }),on:{"click":function($event){return _vm.event(_vm.color)}}})}
var staticRenderFns = []

export { render, staticRenderFns }